import { Autocomplete, TextField } from "@mui/material";
import type { StrandAsset } from "../../models/StrandAsset";

const ALL_STRANDS_VALUE = 0;

interface StrandOption {
  label: string;
  value: number;
}

export const parseStrandNumber = (assetName: string): number | null => {
  const parsedValue = Number.parseInt(assetName.replace(/[^0-9]/g, ""), 10);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

interface StrandSelectorProps {
  value: number | null;
  onChange: (value: number | null) => void;
  strands: StrandAsset[];
}

export const StrandSelector = ({
  value,
  onChange,
  strands,
}: StrandSelectorProps) => {
  const options: StrandOption[] = [
    { label: "All", value: ALL_STRANDS_VALUE },
    ...strands.reduce<StrandOption[]>((accumulated, strand) => {
      const strandNumber = parseStrandNumber(strand.AssetName);
      if (strandNumber === null) return accumulated;
      accumulated.push({ label: String(strandNumber), value: strandNumber });
      return accumulated;
    }, []),
  ];

  const selectedOption =
    options.find((option) => option.value === (value ?? ALL_STRANDS_VALUE)) ??
    options[0];

  return (
    <Autocomplete
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      onChange={(_event, newValue) =>
        onChange(
          !newValue || newValue.value === ALL_STRANDS_VALUE
            ? null
            : newValue.value,
        )
      }
      disableClearable
      size="small"
      renderInput={(params) => (
        <TextField {...params} label="Strand" variant="outlined" />
      )}
    />
  );
};
